<template>
  <div v-if="viewPrintFlg" :viewPrintFlg="viewPrintFlg">
    <div :style="getColor(viewColorIndex)" class="htmlTag">{{this.meal_name}}予約者</div>
    <table border="1" class="table_style ">
      <thead>
        <tr style="background-color: #64B5F6;">
          <th style="width: 25%;">物件名</th>
          <th style="width: 25%;">部屋番号</th>
          <th style="width: 25%;">名前</th>
          <th style="width: 25%;">チェック</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in itemDataList" :key="index">
          <td>{{item.building_name}}</td>
          <td>{{item.room_id}}</td>
          <td>{{item.user_name}}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <div class="htmlCount">
      <h3>予約合計数</h3>
    </div>
    <div class="htmlCount">
      <h3>{{this.itemDataList==null?0:this.itemDataList.length}}</h3>
    </div>
  </div>
  <v-container v-else style="padding: 0px;">
    <v-card flat>
      <v-card-title class="cardTitleStyle">
        <div class="cardTextStyle" :style="getColor(viewColorIndex)">{{this.meal_name}}予約者</div>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="itemDataList" disable-filtering disable-pagination disable-sort
          fixed-header hide-default-footer no-data-text="予約者なし" dense
          style="border: 3px solid #bebebe; border-radius: 0%;">
        </v-data-table>
      </v-card-text>
      <v-card-title class="noPaddingTop">
        <v-row>
          <v-col cols="3">予約合計数</v-col>
          <v-col>{{this.itemDataList==null?0:this.itemDataList.length}}</v-col>
        </v-row>
      </v-card-title>
    </v-card>
  </v-container>
</template>

<script>

  export default {
    name: "ReservationConfirmation",
    components: {
    },
    props: {
      viewPrintFlg: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        headers: [
          {
            text: '物件名',
            value: "building_name",
            class: "blue lighten-2 title",
            align: "center",
            width: "25%",
          },
          {
            text: '部屋番号',
            value: 'room_id',
            class: "blue lighten-2 title",
            align: "center",
            width: "25%",
          },
          {
            text: '名前',
            value: 'user_name',
            class: "blue lighten-2 title",
            align: "center",
            width: "25%",
          },
          {
            text: '予約有無',
            value: 'reserve_flg',
            class: "blue lighten-2 title",
            align: "center",
            width: "25%",
          },
        ],
        viewColorIndex: 0,
        meal_name: "",
        itemDataList: [],
        colors: [
          "#FF9800",//オレンジ
          "#673AB7",//深紫
          "#4CAF50",//緑
          "#E91E63",//ピンク
          "#3F51B5",//インディゴ
          "#009688",//teal
          "#FF5722",//深オレンジ
          "#8BC34A",//light-green
          "#D32F2F",//red darken-2
          "#1565C0"//blue darken-3
        ],
        buildingGroupId: null,
      };
    },
    methods: {
      getColor(value) {
        let colorStyle = {
          background: this.colors[value]
        }

        return colorStyle;
      },
      clearParameters() {

      },
      queryListData(value, colorIndex, mealName) {

        if (value) {
          this.itemDataList = value[0];
        }
        if (colorIndex) {
          this.viewColorIndex = colorIndex;
        }
        if (mealName) {
          this.meal_name = mealName;
        }
      }
    }
  };
</script>

<style scoped>
  .noPaddingTop {
    padding-top: 0px;
  }

  .cardTitleStyle {
    width: 40%;
    padding: 16px 16px 5px 25px;
  }

  .cardTextStyle {
    width: 100%;
    height: 100%;
    color: white;
    text-align: center;
  }

  .table_style td,
  th {
    padding: 10px;
    font-size: 15px;
  }

  .table_style {
    border-collapse: collapse;
    width: 100%;
    text-align: center
  }

  .htmlTag {
    color: white;
    text-align: center;
    font-weight: bold;
    width: 35%;
    margin-bottom: 10px;
    padding: 10px;
  }

  .htmlCount {
    color: black;
    text-align: center;
    width: 20%;
    padding: 10px;
    display: inline-block;
  }
</style>